import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import {
    APP_PAGE_GUTTER_CLASSNAME,
    LIST_PAGE_FRAME_CLASSNAME,
} from '@apps/web/components/layout/page_layout';
import { AgentRulesCard } from '@apps/web/components/settings/agent_rules_card';
import { useDeepLinkOrganization } from '@apps/web/hooks/use_deep_link_organization';
import { useOrganizationId } from '@apps/web/hooks/use_organization_id';
import { useUiV3Components } from '@apps/web/hooks/use_ui_v3_components';
import { cn } from '@apps/web/lib/utils';

const searchSchema = z.object({
    playbook: z.string().optional(),
    // Deep links from Slack and the admin agent-notes page carry the org so the
    // page opens in the note's org, matching the caregivers/clients links.
    // `mode` is accepted for parity with those routes; the note deep link omits
    // it.
    organizationId: z.string().optional(),
    mode: z.enum(['live', 'sandbox']).optional(),
});

export const Route = createFileRoute('/_app/(main)/playbooks')({
    component: PlaybooksPage,
    head: () => ({
        meta: [
            {
                title: 'Playbooks | Phoebe',
            },
        ],
    }),
    validateSearch: searchSchema,
});

function PlaybooksPage() {
    const {
        playbook: initialPlaybookId,
        organizationId: deepLinkOrganizationId,
        mode: deepLinkMode,
    } = Route.useSearch();
    const { isWaitingForDeepLinkOrganization } = useDeepLinkOrganization(
        deepLinkOrganizationId,
        deepLinkMode,
    );
    const organizationId = useOrganizationId();
    const redesigned = useUiV3Components();

    if (isWaitingForDeepLinkOrganization) {
        return null;
    }

    return (
        <div
            className={
                redesigned
                    ? cn(LIST_PAGE_FRAME_CLASSNAME, 'mx-auto w-full min-w-0')
                    : cn(
                          APP_PAGE_GUTTER_CLASSNAME,
                          'container mx-auto max-w-5xl',
                      )
            }
        >
            <AgentRulesCard
                organizationId={organizationId}
                redesigned={redesigned}
                initialPlaybookId={initialPlaybookId ?? null}
            />
        </div>
    );
}
